import { updateInitialConfig, updateModifiedConfig } from "../checksumStore";
const stateKeys = ["allow_state_targets", "deny_states_targets", "allow_state_sources", "deny_states_sources"];

const activityKeys = ["allow_activities", "deny_activities", "source_activity"];
export const updateStateChecksum = (stateData, isInit) => {
  let storeConfig = {
    remember: stateData.remember,
    description: stateData.description
  };

  if (isInit) {
    updateInitialConfig(storeConfig);
  } else {
    updateModifiedConfig(storeConfig);
  }
  return storeConfig;
};

export const getInitialConfigForState = (stateData, states = [], activities = []) => {
  const newConfig = { ...stateData };
  const updatedRemember = filterStatesAndActivities(stateData.remember, states, activities);
  newConfig.remember = updatedRemember;
  return newConfig;
};

const filterStatesAndActivities = (data, states = [], activities = []) => {
  const result = {};

  for (const field in data) {
    const originalArray = Array.isArray(data[field]) ? data[field] : [];

    if (stateKeys.includes(field)) {
      result[field] = originalArray.filter((id) => states.some((item) => item.id === id));
    } else if (activityKeys.includes(field)) {
      result[field] = originalArray.filter((id) => activities.some((item) => item.id === id));
    } else {
      result[field] = originalArray;
    }
  }

  return result;
};
